import React from "react";

interface DividerProps {
  className?: string;
}

/**
 * Divider
 *
 * A simple horizontal line used to visually separate sections or elements.
 * Uses a subtle border color defined by `--bg-reset-button` for theme consistency.
 */
const Divider: React.FC<DividerProps> = ({ className = "" }) => (
  <div className={`border-b border-b-[var(--bg-reset-button)] ${className}`} />
);

export default Divider;
